import { Spinner, SpinnerProps } from "@chakra-ui/react";
import { AnimatePresence, motion, MotionProps } from "framer-motion";

export const MotionSpinner = motion<SpinnerProps>(Spinner);

/**
 * Use this to show a spinner that gently fades in and out when shown.
 * Useful for "inline" spinners that's shown next to other fixed components
 * and where loading happens in the background/continiously.
 * For other cases, use `DelayedSpinner` or use Chakra's `Spinner` directly.
 */
export default function AnimatedSpinner({
  show = false,
  ...props
}: SpinnerProps & MotionProps & { show: boolean }) {
  return (
    <AnimatePresence>
      {show && (
        <MotionSpinner
          key="spinner"
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          initial={{ opacity: 0 }}
          transition={{ type: "tween", duration: 0.1 } as any}
          {...props}
        />
      )}
    </AnimatePresence>
  );
}
